export const STORAGE_TOKEN = 'token';
export const STORAGE_IDLE_TIME_UTC = 'idleTimeUTC';
export const STORAGE_DISTRICT_ID = 'districtId';
export const STORAGE_FORCE_LOG_OUT = 'forceLogOut';
export const DONT_SHOW_REDUX_ERROR = 'DONT_SHOW_REDUX_ERROR';



// WEBPACK FOOTER //
// ./src/common/Constants/storage.js